import { sendCPLog } from "../../../Utils/Log/CPlog";
import * as S from "./Benefit.style";
import { RightArrow } from "./RightArrow.svg";
import {config} from "../../../config";

export const BenefitNb = () => {
  return (
    <S.Container>
      <S.Badge>추가 혜택</S.Badge>
      <S.Gap size={8} />
      <S.SubTitle>IT 역량을 기르고 싶다면?</S.SubTitle>
      <S.Gap size={20} />
      <S.Title>
        <span>선착순 200명</span>에게
        <br />
        <span>50만 원 추가 지원금</span>까지!
      </S.Title>
      <S.Gap size={30} />
      <S.BenefitImg src={`/benefit_nb.png`} />
      <S.Gap size={30} />
      <S.Cta
        onClick={() => {
          sendCPLog("nb_quiz_click_button", {
            "button_text": "바로 사용하러가기"
          })
          window.open(`${config.scc.url}/nb`);
        }}
      >
        바로 사용하러가기 <RightArrow />
      </S.Cta>
      <S.Gap size={30} />
    </S.Container>
  );
};
